import { AutogenModelBrltlEdiOrderHdrXFgp, AutogenRowBrltlEdiOrderHdrXFgp } from "./autogen/AutogenModelBrltlEdiOrderHdrXFgp";

export class ModelBrltlEdiOrderHdrXFgp extends AutogenModelBrltlEdiOrderHdrXFgp<RowBrltlEdiOrderHdrXFgp> {
	constructor() {
		super(RowBrltlEdiOrderHdrXFgp);
	}
}

export class RowBrltlEdiOrderHdrXFgp extends AutogenRowBrltlEdiOrderHdrXFgp {
}